// Pure validation for the Manage Students "add students" rows (AIT-267).

export const GRADE_REQUIRED_MESSAGE = "Grade is required";

const isFilled = (v) => v != null && String(v).trim() !== "";

// A row counts as "started" exactly when buildUsersPayload would keep it:
// first name or contact number is non-empty, or the grade parses to a
// truthy integer. Gender, roll number and last name alone do not count, and
// neither does the pre-filled country code.
export function isRowStarted(row) {
  if (!row) return false;
  const grade = parseInt(row.grade_no, 10);
  return isFilled(row.fname) || isFilled(row.contact_number) || !!grade;
}

export function hasStartedRow(rows) {
  return Array.isArray(rows) && rows.some(isRowStarted);
}

function hasValidGrade(row) {
  const n = parseInt(String(row.grade_no ?? "").trim(), 10);
  return Number.isInteger(n) && n > 0;
}

// Returns { [rowIndex]: { grade: "Grade is required" } } for started rows
// that lack a usable grade. Message is the English key; callers wrap in t().
export function validateStudentRows(rows) {
  if (!Array.isArray(rows)) return {};
  const errors = {};
  rows.forEach((row, i) => {
    if (isRowStarted(row) && !hasValidGrade(row)) {
      errors[i] = { grade: GRADE_REQUIRED_MESSAGE };
    }
  });
  return errors;
}

// After removing row `removedIndex`, drop its error and shift the errors of
// later rows down by one. Returns a new object.
export function reindexRowErrorsAfterRemoval(errors, removedIndex) {
  const next = {};
  Object.keys(errors || {}).forEach((key) => {
    const i = Number(key);
    if (i < removedIndex) next[i] = errors[key];
    else if (i > removedIndex) next[i - 1] = errors[key];
  });
  return next;
}
